import React, {useRef} from "react";
import {Paper} from "@material-ui/core";
import replay from "../images/replay.png";
import pause from "../images/pause.png";
import play from "../images/play.png";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    grid: {
        width: '100%',
        marginLeft: '400px',
        marginRight: '400px',
        background: '#0F5FAF'
    },

    paper: {
        padding: theme.spacing(0),
        textAlign: 'center',
        borderRadius: '5px',
        color: '#000',
        background: '#6AADE4',
    }
}));

export const Podcast = ({
    sound
}) => {

    // Hooks
    const classes = useStyles();
    const audioRef = useRef(null);

    // Helper functions
    const playAudio = () => audioRef.current.play();
    const pauseAudio = () => audioRef.current.pause();
    const refreshAudio = () => audioRef.current.currentTime = 0;

    // Template
    return <>
        <audio className="audio-element" ref={audioRef}>
            <source src={sound}/>
        </audio>
        <button className={"btn btn--primary--solid"} onClick={refreshAudio}>
            <Paper className={classes.paper}>
                <img src={replay}/>
            </Paper>
        </button>
        <button className={"btn btn--primary--solid"} onClick={pauseAudio}>
            <Paper className={classes.paper}>
                <img src={pause}/>
            </Paper>
        </button>
        <button className={"btn btn--primary--solid"} onClick={playAudio}>
            <Paper className={classes.paper}>
                <img src={play}/>
            </Paper>
        </button>
    </>;
}
